module.exports = __webpack_public_path__ + "assets/fs-tuihuoshouhou.be38eb49.svg";